import React from 'react';

var Delivery = function Delivery(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Delivery"), /*#__PURE__*/React.createElement("path", {
    d: "M19.647 11.985L16.12 8.444a.952.952 0 0 1 1.349-1.345l4.084 4.098v2.427a2.709 2.709 0 0 1-2.71 2.71H5.21a2.709 2.709 0 0 1-2.709-2.71V5.71A2.709 2.709 0 0 1 5.209 3h6.956a2.709 2.709 0 0 1 2.71 2.709v5.882a.952.952 0 1 1-1.905 0V5.709a.804.804 0 0 0-.805-.804H5.21a.804.804 0 0 0-.804.804v7.915c0 .445.36.805.804.805h13.634c.444 0 .804-.36.804-.805v-1.64zm-2.861 9.11a1.905 1.905 0 1 1 0-3.81 1.905 1.905 0 0 1 0 3.81zm-9.524 0a1.905 1.905 0 1 1 0-3.81 1.905 1.905 0 0 1 0 3.81z",
    fill: "currentColor"
  }));
};

Delivery.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import iconHandler from './hoc';
export { Delivery as icon };
export default iconHandler(Delivery);